import axios from "axios";
import config from '../config.js';

async function createProcessingRequest(jwt,procID, subprocIDs)
{
  const dataForm = new FormData();
  const data = {
    processing: procID,
    subprocessings: subprocIDs,
    done: false
  };
  dataForm.append('data', JSON.stringify(data));
  let response = await axios.post(`${config.apiUrl}/api/processing-requests`, dataForm, {
    headers: {
      Authorization: `Bearer ${jwt}`,
    }
  });
  //console.log(response)
  return response.data.data.id;
}

async function deletingProcessingRequest(jwt,procID)
{
  let response = await axios.delete(`${config.apiUrl}/api/processing-requests/${procID}`, {
    headers: {
      Authorization: `Bearer ${jwt}`,
    }
  });
  //console.log(response)
  return response.data.data.id;
}

async function updatingProcessingRequest(jwt, procID, subprocIDs)
{
  const dataForm = new FormData();
  const data = {
    subprocessings: subprocIDs,
    done: false
  };
  dataForm.append('data', JSON.stringify(data));
  let response = await axios.put(`${config.apiUrl}/api/processing-requests/${procID}`, dataForm, {
    headers: {
      Authorization: `Bearer ${jwt}`,
    }
  });
  //console.log(response)
  return response.data.data.id;
}

export async function createProcessingRequestIds(jwt,processings){
    let processingRequestIds=[];
    for (const req of processings) {
        try {
          const createdId = await createProcessingRequest(jwt,req.processing, req.subprocessings);
          processingRequestIds.push(createdId)
          console.log(`Created processing request with id: ${createdId}`);
        } catch (error) {
          console.error(
            `Error creating processing request for processing id ${req.processing}:`,
            error
          );
        }
      }
    return processingRequestIds;  
}

export async function updateProcessingRequestIds(jwt, initial, processings) {
  //console.log("Initial requests:", initial);
  //console.log("New requests:", processings);

  const processingRequestIds = [];

  // Build maps keyed by processing id.
  const initialMap = new Map();
  initial.forEach(req => {
    // Each initial request already has an 'id'
    initialMap.set(req.processing, req);
  });

  const newMap = new Map();
  processings.forEach(req => {
    newMap.set(req.processing, req);
  });

  // Process new requests: create new ones or update existing ones.
  for (const [procId, newReq] of newMap.entries()) {
    if (!initialMap.has(procId)) {
      // New processing request: create it.
      const newId = await createProcessingRequest(jwt, newReq.processing, newReq.subprocessings);
      processingRequestIds.push(newId);
    } else {
      // Request exists already: compare the subprocessings.
      const oldReq = initialMap.get(procId);
      // Compare arrays after sorting (order-insensitive)
      const oldSubs = [...oldReq.subprocessings].sort().join(',');
      const newSubs = [...newReq.subprocessings].sort().join(',');
      if (oldSubs !== newSubs) {
        // Subprocessings changed: update the processing request.
        const updatedId = await updatingProcessingRequest(jwt, oldReq.id, newReq.subprocessings);
        processingRequestIds.push(updatedId);
      } else {
        // Unchanged: reuse the old request's id.
        processingRequestIds.push(oldReq.id);
      }
    }
  }

  // Process deletions: remove any processing request that exists in the initial list but not in the new list.
  for (const [procId, oldReq] of initialMap.entries()) {
    if (!newMap.has(procId)) {
      await deletingProcessingRequest(jwt, oldReq.id);
    }
  }

  return processingRequestIds;
}

export function getRequestCountByUser(user)
{
    let n = user.projects.reduce((acc, project) => {
        const projectData = project.data || [];
        projectData.forEach(dataItem => {
            dataItem.processing_requests.forEach(proc => {  
            if (proc.done === false) {
                acc++;
            }
         });
        });
        return acc;
      }, 0);
    return n;
}

export function getRequestCountByData(data)
{
    let acc=0;
    const processing_req = data.processing_requests || [];
    processing_req.forEach(req => {
        if (req.done === false) {
            acc++;
        }
    });
    return acc;
}

export function extractIdsByTitles(inputTitles, processings) {
  const titleSet = new Set(inputTitles);
  const result = [];

  processings.forEach(proc => {
    // Check if the parent processing is selected.
    const processingSelected = titleSet.has(proc.title);
    
    // Get the IDs of all subprocessings that are selected.
    const selectedSubIds = (proc.subProcessings || [])
      .filter(sub => titleSet.has(sub.title))
      .map(sub => sub.id);

    // If either the processing or at least one subprocessing is selected,
    // include this processing in the result.
    if (processingSelected || selectedSubIds.length > 0) {
      result.push({
        processing: proc.id,
        subprocessings: selectedSubIds,
      });
    }
  });

  return result;
}
